import React from 'react';
import { FadeIn } from './FadeIn';
export function Section2() {
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-126">
      <FadeIn data-id="element-127">
        <div className="border-l-4 border-gold pl-8 py-2 mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-dark" data-id="element-129">
            LA VERDAD QUE NADIE TE DICE
          </h2>
        </div>
      </FadeIn>

      <div className="space-y-8 text-lg text-dark-light leading-relaxed" data-id="element-130">
        <FadeIn delay={0.2} data-id="element-131">
          <p className="text-2xl font-serif text-dark" data-id="element-132">
            Los abogados de crédito no son tus aliados. Son un negocio.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-133">
          <p data-id="element-134">
            Su modelo funciona así: mientras más lento arreglen tu crédito, más
            meses te cobran. Si lo arreglaran en 30 días, perderían su ingreso
            mensual. Por eso las cartas que envían son lentas, genéricas y
            diseñadas para mantener el proceso vivo, no para terminarlo.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-135">
          <p data-id="element-136">
            ¿Y los cursos de finanzas en YouTube? Información incompleta,
            mezclada con inglés técnico que nunca nadie te traduce de verdad.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-137">
          <p className="text-xl font-medium text-gold-dark italic" data-id="element-138">
            Nadie te estaba dando la hoja de ruta completa. Hasta hoy.
          </p>
        </FadeIn>
      </div>
    </section>;
}